import React from 'react';
import Label from './Label';
import styled from 'styled-components';
const ErrorMessage = ({ title, titleParams, subtitle, subtitleParams }) => {
    const subtitleTag = subtitle ?
        React.createElement(ErrorSubtitle, { text: subtitle, parameters: subtitleParams }) : '';
    return React.createElement(ErrorMessageWrapper, null,
        React.createElement(ErrorTitle, { text: title, parameters: titleParams }),
        subtitleTag);
};
const ErrorMessageWrapper = styled.div `
  display: block;
  width: 50%;

  margin: 15px auto;

  color: ${props => props.theme.colors.textOrange};
  text-align: center;
`;
const ErrorTitle = styled(Label) `
  display: block;
  color: ${props => props.theme.colors.textOrange};

  text-align: center;
  font-family: ${props => props.theme.fonts.demi};
  font-size: 14px;
`;
const ErrorSubtitle = styled(Label) `
  display: block;
  margin-top: 7px;

  color: ${props => props.theme.colors.textOrange};
  text-align: center;
  font-size: 12px;
`;
export default ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map